import { useCallback } from 'react';
import PropTypes from 'prop-types';

// Our Components
import TextInput from 'components/Input/TextInput';

// Our PropTypes
import CommonPropTypes from 'shared/prop-types';

// Input types
import { PERCENT } from 'components/Input/Types';

function RateInput({
	disabled,
	rate,
	setRate,
	sx,
	inputSx,
	label,
	labelSx,
	subLabel,
	inputProps,
	variant,
	required
}) {
	const handleRateChange = useCallback((value) => {
		const isValueEmpty = value === '';
		if (isValueEmpty) {
			setRate('');
			return;
		}
		const number = +value;
		const isWithinRange = number >= 0 && number <= 100;
		const hasDecimal = value.includes('.');
		if (!hasDecimal && value && value.length > 3) return;
		const decimalIndex = value.indexOf('.');

		if (isWithinRange) {
			const startsWithZero =
				value && value.length > 1 && value[0] === '0';
			if (hasDecimal) {
				const numbersBeforeDecimal = value.slice(0, decimalIndex);
				if (numbersBeforeDecimal.length >= 2) {
					const isAllZeroesBeforeDecimal = numbersBeforeDecimal
						.split('')
						.every((char) => char === '0');
					if (isAllZeroesBeforeDecimal) return;
				}

				const numbersAfterDecimal = value.slice(
					decimalIndex + 1,
					value.length
				);
				if (numbersAfterDecimal.length > 3) return;
			} else if (startsWithZero) {
				const isOnlyZeroes = value
					.split('')
					.every((char) => char === '0');
				if (isOnlyZeroes) return;
			}
			setRate(value);
		}
	}, []);

	return (
		<TextInput
			label={label}
			labelSx={labelSx}
			onChange={handleRateChange}
			subLabel={subLabel}
			sx={sx}
			type={PERCENT}
			value={rate}
			variant={variant}
			inputProps={inputProps}
			inputSx={inputSx}
			disabled={disabled}
			required={required}
		/>
	);
}

RateInput.propTypes = {
	rate: PropTypes.string.isRequired,
	setRate: PropTypes.func.isRequired,
	sx: CommonPropTypes.sx,
	inputSx: CommonPropTypes.sx,
	label: PropTypes.string,
	labelSx: CommonPropTypes.sx,
	subLabel: PropTypes.string,
	disabled: PropTypes.bool,
	variant: PropTypes.string,
	required: PropTypes.bool
};

RateInput.defaultProps = {
	sx: {},
	inputSx: {},
	label: 'Rate',
	labelSx: {},
	subLabel: 'Estimate is fine',
	disabled: false,
	variant: 'subtitle2',
	required: false
};

export default RateInput;
